const removSpacesAndAccents = (value) => {
    const stringV = String(value);
    let newValue = stringV
      .split(' ')
      // Quebra pelos espaços
      .filter((item) => item !== '')
      // Remove do array itens vazios (quando é encontrado espaço duplo)
      .join('')
      // Junta as palavras restantes com espaço
    if (value && stringV[stringV.length - 1] === ' ') {
      newValue = `${newValue} `;
    }
    return newValue;
  };

  export default {
    removSpacesAndAccents,
  };